import { gql } from 'urql';

export const RECOMMENDATIONS_QUERY = gql`
  query RecommendationsWithDetails($pageType: String!, $ids: [ID!]) {
    recommendationsWithDetails(pageType: $pageType, ids: $ids) {
      recommenderId
      recommenderName
      recommendations {
        masterId
        variantProduct {
          id
          masterId
          name
          colorValue
          productPrice {
            price
            salePrice
            promotionPrice
            isSalePriceElapsed
          }
          displayOutOfStock {
            displayValue
          }
          header
          subHeader
          images {
            href
            alt
          }
        }
      }
    }
  }
`;
